import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import { formatWorkHistoryLayerList } from './work-history-layer.helper';
import { WorkHistoryLayerActions } from './work-history-layer.redux';
import { IPayloadGetWorkHistoryLayerListRequest } from './work-history-layer.type';

export function* getWorkHistoryLayerList(
	action: PayloadAction<IPayloadGetWorkHistoryLayerListRequest>
) {
	const { applicantId, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetAssignmentHistoryLayerListResponse> =
			yield API.getAssignmentWorkHistoryLayerList(applicantId);

		const content = formatWorkHistoryLayerList(res?.data);

		yield put(
			WorkHistoryLayerActions.getWorkHistoryLayerListSuccess({
				content,
			})
		);

		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkHistoryLayerActions.getWorkHistoryLayerListFailure());
	}
}
